import qs from 'qs'

export default function locationParams() {
  if (!window.location.search) return {}

  const normalizedSearch = (window.location.search[0] === '?' ? window.location.search.substr(1, window.location.search.length) : window.location.search)
  return qs.parse(normalizedSearch)
}



// WEBPACK FOOTER //
// ./src/utils/locationParams.js